export var DISQUE100_FILTERABLE_TABS = new Set([
    0, 1, 2, 3,
]);
export var DISQUE100_SUBTAB_ID_BY_TAB = {
    0: "denuncias",
    1: "vitimas",
    2: "violacoes",
    3: "outros",
};
export var isDisque100TabValue = function (tab) { return typeof tab === "number" && tab >= 0 && tab <= 3; };
export var isPeriodFilterActive = function (tab, years) {
    return (tab === 0 || tab === 1 || tab === 2) && years.length > 0;
};
